import { format } from 'date-fns';
import Highcharts from 'highcharts';
import { MONTHLY_INTERVAL } from 'shared/constants';
import { formatUnit } from 'shared/utils';
import {
  WHITE_COLOR,
  CHART_TOOLTIP_TEXT_COLOR,
  AXIS_LABEL_DATE_FORMAT,
  GRID_LINE_COLOR,
  LABEL_OPACITY,
  TITLE_TEXT,
  AXIS_LABEL_DATE_FORMAT_LONG,
} from 'shared/components/TimeseriesChart/constants';
import { TimeserieChartVar99DataMock, TimeseriesChartDataMock } from '../mocks';

export const varSeriesLabel = (name: string): string => `VaR (${name})`;

export const varSeries = TimeserieChartVar99DataMock.map(
  ({ name, data: tsData }) => ({
    name: varSeriesLabel(name),
    data: tsData,
  })
);

export const pnlSeries = {
  name: 'P&L',
  data: TimeseriesChartDataMock[0].data,
};

export const getCustomOptions = (): Highcharts.Options => {
  return {
    title: {
      text: 'Global Bond Fund  /  Exceptions Breakdown',
      align: 'left',
      style: { color: WHITE_COLOR, fontSize: '14px' },
    },
    tooltip: {
      backgroundColor: WHITE_COLOR,
      padding: 15,
      style: { color: CHART_TOOLTIP_TEXT_COLOR, padding: '10px' },
      formatter() {
        return `${format(
          this.point.x,
          AXIS_LABEL_DATE_FORMAT_LONG
        )}<br />Value: ${formatUnit(this.point.y)}`;
      },
    },
    xAxis: {
      tickColor: 'none',
      lineColor: 'none',
      gridLineColor: GRID_LINE_COLOR,
      labels: {
        style: {
          color: WHITE_COLOR,
          opacity: LABEL_OPACITY,
        },
        formatter: (item) => {
          return format(new Date(item.value), AXIS_LABEL_DATE_FORMAT);
        },
      },
      tickInterval: MONTHLY_INTERVAL,
    },
    yAxis: {
      tickInterval: 50000,
      alignTicks: true,
      title: {
        text: TITLE_TEXT,
        style: { color: WHITE_COLOR },
      },
      labels: {
        style: {
          color: WHITE_COLOR,
          opacity: LABEL_OPACITY,
        },
        formatter: (item) =>
          new Intl.NumberFormat('en-GB', {
            notation: 'compact',
          }).format(parseFloat(item.value)),
      },
      gridLineColor: GRID_LINE_COLOR,
    },
  };
};
